import { render, staticRenderFns } from "./PaymentWireTransferForm.vue?vue&type=template&id=5aca2bee"
import script from "./PaymentWireTransferForm.vue?vue&type=script&lang=js"
export * from "./PaymentWireTransferForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports